module.exports = __webpack_public_path__ + "prod/1.42.2/img/41@2x.2738d0d6.png";